export default {
  order: 7,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'FOREST_CARBON_GROSS_EMISSIONS',
    order: 7,
    type: 'remoteDataLayer',
    uuid: '0b45cb69-6432-449f-af38-25cdcda85d55',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: 'Forest Greenhouse Gas Emissions (2001-2024)',
          fr: 'Émissions de gaz à effet de serre provenant des forêts',
          es: 'Emisiones de gases de efecto invernadero en los bosques',
          pt: 'Emissões de Gases de Efeito Estufa Florestais',
          id: 'Emisi Gas Rumah Kaca dari Hutan',
          zh: '森林温室气体排放',
          ka: 'Орманның жауапкершілік тауып қазуылары',
        },
        type: 'gradient',
        items: [
          {
            color: 'rgb(123, 59, 127)',
            name: {
              en: '>1500 tCO₂e ha⁻¹',
              fr: '>1500 tCO₂e ha⁻¹',
              es: '>1500 tCO₂e ha⁻¹',
              pt: '>1500 tCO₂e ha⁻¹',
              id: '>1500 tCO₂e ha⁻¹',
              zh: '>1500 tCO₂e ha⁻¹',
              ka: '>1500 tCO₂e ha⁻¹',
            },
          },
          {
            color: 'rgb(140, 79, 160)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
            },
          },
          {
            color: 'rgb(173, 145, 229)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
            },
          },
          {
            color: 'rgb(209, 201, 227)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
            },
          },
          {
            color: 'rgb(245, 237, 242)',
            name: {
              en: '0',
              fr: '0',
              es: '0',
              pt: '0',
              id: '0',
              zh: '0',
              ka: '0',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'FOREST_CARBON_GROSS_EMISSIONS',
    type: 'forest-carbon-gross-emissions',
    url: 'https://tiles.globalforestwatch.org/gfw_forest_carbon_gross_emissions/v20250430/tcd_{tcd}/{z}/{x}/{y}.png',
    technicalName: 'wri_forest_carbon_gross_emission',
    label: {
      en: 'Forest Greenhouse Gas Emissions',
      fr: 'Émissions de gaz à effet de serre provenant des forêts',
      es: 'Emisiones de gases de efecto invernadero en los bosques',
      pt: 'Emissões de Gases de Efeito Estufa Florestais',
      id: 'Emisi Gas Rumah Kaca dari Hutan',
      zh: '森林温室气体排放',
      ka: 'Орманның жауапкершілік тауып қазуылары',
    },
    sublabel: {
      en: '30m, global, 2001-2024, Harris et al. 2024',
      fr: '30m, global, 2001-2024, Harris et al. 2024',
      es: '30m, global, 2001-2024, Harris et al. 2024',
      pt: '30m, global, 2001-2024, Harris et al. 2024',
      id: '30m, global, 2001-2024, Harris et al. 2024',
      zh: '30m, global, 2001-2024, Harris et al. 2024',
      ka: '30m, global, 2001-2024, Harris et al. 2024',
    },
  },
  isMetadataError: false,
  isError: false,
};
